import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/crystaSurelogo.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-4dbd60aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar bg-white p-0 sticky z-50 top-0 left-0 flex shadow" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full flex justify-center items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "lg:flex cursor-pointer" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "text-lg font-bold cursor-pointer" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_0,
        alt: "",
        class: "crystallineLogo"
      })
    ])
  ])
], -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}